import { render, staticRenderFns } from "./Fall.vue?vue&type=template&id=08c7c652&scoped=true&"
import script from "./Fall.vue?vue&type=script&lang=js&"
export * from "./Fall.vue?vue&type=script&lang=js&"
import style0 from "./Fall.vue?vue&type=style&index=0&id=08c7c652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7c652",
  null
  
)

export default component.exports